<template>
    <div class="d-flex justify-content-center align-items-center form-data">
        <div>

            <div v-if="showConfirmAccount" class="px-3 py-2 mb-3 bg-lighter border-darker radius-normal">
                <h4 class="mb-1 darker mt-0 bold">Your account was successfully created!</h4>
                <p class="fs-small darker">
                    We've sent a confirmation email to your address, once you validate your account it will be ready to use.
                </p>
            </div>

            <div v-if="showConfirmedAccount" class="px-3 py-2 mb-3 bg-lighter border-darker radius-normal">
                <h4 class="mb-1 darker mt-0 bold">Your account was successfully confirmed!</h4>
                <p class="fs-small darker">
                    All set! You can now login with your brand new account, enjoy!
                </p>
            </div>

            <h1 class="mb-3">Sign in to Pluralo</h1>
            <div class="dark mb-5">Enter your details below.</div>

            <form @submit.stop.prevent="triggerLogin" :class="['shaded', status]" novalidate>
                <div class="form-group">
                    <label class="full">
                        Email
                        <input class="full" v-model="username" type="text" placeholder="Email" autofocus required>
                    </label>
                </div>

                <div class="form-group">
                    <label class="full">
                        Password
                        <input class="full" v-model="password" type="password" placeholder="Password" required>
                    </label>
                </div>

                <input type="submit" class="btn action widest full" value="Sign in" :disabled="getIsTryingLogin" >

                <router-link :to="{ name: 'auth.signup.forgot' }" class="fs-smaller back">
                    Forgot your password?
                </router-link>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ForgotPassword from './ForgotPassword'
    import { required, email, minLength } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                username: '',
                password: '',
                rememberMe: true,
                status: '',
            }
        },
        props: {
            showConfirmedAccount: {
                type: Boolean,
                default: false
            }
        },
        validations: {
            username: {
                required,
                email,
            },
            password: {
                minLength: minLength(4)
            }
        },
        created: function() {
            this.eventHub.$emit('sidebar', 'login');
            this.eventHub.$emit('topLink', 'signup');
            this.resetAccountSetup('agent');
            this.resetAccountSetup();
        },
        computed: {
            ...mapGetters([
                'getIsTryingLogin'
            ]),
            showConfirmAccount: function () {
                return this.$route.params.validateAccount? this.$route.params.validateAccount : false
            }
        },
        methods: {
            ...mapActions([
                'login',
                'resetAccountSetup'
            ]),
            triggerLogin: function() {
                let params = {
                    grant_type: 'password',
                    client_id:  'agentAuthApp',
                    username:   this.username,
                    password:   this.password,
                    remember:   this.rememberMe,
                };

                this.login({ params: this.parseQueryString(params), query: this.$route.query });
            },
            resetForm: function() {
                this.password = '';
            }
        },
        components: {
            ForgotPassword
        }
    }
</script>



// WEBPACK FOOTER //
// Login.vue?875073f0